export const COMPONENT_NAME = 'EditableField';

export const COMMANDS = {
	CREATE: COMPONENT_NAME + 'Create',
	GET_CONTENT: COMPONENT_NAME + 'GetContent',
	SET_CONTENT: COMPONENT_NAME + 'SetContent',
	SET_IS_UPDATING: COMPONENT_NAME + 'SetIsUpdating',
	DIFF: COMPONENT_NAME + 'Diff',
	DIFF_BULK: COMPONENT_NAME + 'DiffBulk',
	ENABLED: COMPONENT_NAME + 'SetEnabled'
};

export const COMPONENT_TITLE = COMPONENT_NAME + 'Title';
export const COMPONENT_ATTR_ID = COMPONENT_NAME + 'ID';
export const COMPONENT_ATTR_NAME = COMPONENT_NAME + 'Name';
export const COMPONENT_ATTR_UPDATING = COMPONENT_NAME + 'Updating';
export const COMPONENT_ATTR_NEW_VALUE = COMPONENT_NAME + 'NewValue';
export const COMPONENT_ATTR_CAN_REVIEW = COMPONENT_NAME + 'CanReview';
export const COMPONENT_ATTR_EDITING_ENABLED = 'editing-enabled';

export const OUT_COMMANDS = {
	CREATE: `${ COMPONENT_NAME }.create`,
	GET_CONTENT: `${ COMPONENT_NAME }.getContent`,
	SET_CONTENT: `${ COMPONENT_NAME }.setContent`,
	SET_IS_UPDATING: `${ COMPONENT_NAME }.setIsUpdating`,
	CHANGE: `${ COMPONENT_NAME }.change.text`,
	DIFF: `${ COMPONENT_NAME }.diff`,
	DIFF_REVIEW: `${ COMPONENT_NAME }.diffReview`,
	DIFF_BULK: `${ COMPONENT_NAME }.diffBulk`,
	ENABLED: `${ COMPONENT_NAME }.enabled`
};
